import { RoundManager } from "../../Round/RoundManager";
import { Stadium } from "../../Stadium/Stadium";
import { TargetBase } from "../Targets/Target";
import { TargetSettingsBase } from "../TargetSettings";



export abstract class TargetControllerBase {
    protected _target: TargetBase;
    protected _settings: TargetSettingsBase;

    get pos(): pc.Vec2 { return this._pos; }
    protected _pos = new pc.Vec2;

    protected _prevTargetInitPos: pc.Vec2;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(target: TargetBase, settings: TargetSettingsBase): void {
        this._target = target;
        this._settings = settings;

        if ((settings.flags & (TargetSettingsBase.FLAG_USE_PREV_TARGET_X | TargetSettingsBase.FLAG_USE_PREV_TARGET_Y | TargetSettingsBase.FLAG_OFFSET_FROM_PREV_TARGET_X | TargetSettingsBase.FLAG_OFFSET_FROM_PREV_TARGET_Y)) != 0)
            this._prevTargetInitPos = target.prevTarget.controller.getPositionInTime(target.stateTime);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    restart(): void {
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci pozici terce v zadany cas
     * @param time 
     * @returns 
     */
    //-------------------------------------------------------------------------
    getPositionInTime(time: number): pc.Vec2 {
        return this._pos;
    }

    //-------------------------------------------------------------------------
    /**
     * Prevod x a y (ktery obsahuji pomerovou pozici v ramci brany) na pozici v hernim svete
     * @param x 
     * @param y 
     * @param screenPos 
     */
    //-------------------------------------------------------------------------
    convertRatioPos2WorldPos(x: number, y: number, screenPos?: pc.Vec2): void {
        if (!screenPos)
            screenPos = this._pos;

        // Pozice
        let flags = this._settings.flags;

        if ((flags & TargetSettingsBase.FLAG_USE_PREV_TARGET_X) != 0) {
            screenPos.x = this._prevTargetInitPos.x;
        }
        else {
            let hSpace = this._target.goalHSpace;

            if ((flags & TargetSettingsBase.FLAG_OFFSET_FROM_PREV_TARGET_X) != 0) {
                screenPos.x = this._prevTargetInitPos.x;

                if (RoundManager.instance.roundSetup.flippedHorizontally)
                    x = -x;
            }
            else {
                screenPos.x = Stadium.CENTER_X - hSpace / 2;

                if (RoundManager.instance.roundSetup.flippedHorizontally)
                    x = 1 - x;
            }

            screenPos.x += x * hSpace;
        }

        if ((flags & TargetSettingsBase.FLAG_USE_PREV_TARGET_Y) != 0) {
            screenPos.y = this._prevTargetInitPos.y;
        }
        else {
            let vSpace = this._target.goalVSpace;

            if ((flags & TargetSettingsBase.FLAG_OFFSET_FROM_PREV_TARGET_Y) != 0) {
                screenPos.y = this._prevTargetInitPos.y;
            }
            else {
                screenPos.y = (Stadium.GOAL_HEIGHT - vSpace) / 2;
            }

            screenPos.y += y * vSpace;
        }
    }
}



/**
 * Animace vlastnosti terce
 */
export class TargetPropAnim {
    private _fromValue: number;
    private _toValue: number;
    private _time: number;
    private _ease: (k: number) => number;

    get time(): number { return this._time; }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(fromVal: number, toVal: number, time: number, ease: (k: number) => number) {
        this._fromValue = fromVal;
        this._toValue = toVal;
        this._time = time;
        this._ease = ease;
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci aktualni hodnotu animace. Pokud time > celkova delka animace, tak vraci undefined
     * @param time Cas, pro ktery chceme ziskat hodnotu
     * @returns 
     */
    //-------------------------------------------------------------------------
    getAnimVal(time: number): number {
        if (time < 0 || time >= this._time)
            return undefined;

        return this._fromValue + (this._toValue - this._fromValue) * this._ease(time / this._time);
    }
}